module.exports = __webpack_public_path__ + "img/no4.71dde141.svg";